import { fetcher } from "./utils";

export type User = {
    id: string;
    username: string;
    email: string;
    isBlocked?: boolean;
    // Add other user properties as needed
};

export type AdminResponse = {
    success?: boolean;
    error?: string;
    message?: string;
};

export type PasswordRenewalInterval = 7 | 30 | 90 | 180;
export type SesstionDuration = 3 | 10 | 30 | 60 | 120 | 180;

// Block users
export const blockUsers = async (
    username: string,
    is_block: boolean
): Promise<AdminResponse> => {
    const response = await fetcher("/admin/block-users", {
        method: "PUT",
        data: { username, is_block },
    });
    return response;
};

// Set password renewal interval
export const setPasswordRenewalInterval = async (
    username: string,
    intervalInDays: PasswordRenewalInterval
): Promise<AdminResponse> => {
    const response = await fetcher("/admin/password-renew-interval", {
        method: "PUT",
        data: { username, interval: String(intervalInDays) },
    });
    return response;
};

// Set session duration
export const setSessionDuration = async (
    username: string,
    durationMinutes: SesstionDuration
): Promise<AdminResponse> => {
    const response = await fetcher("/admin/session-duration", {
        method: "PUT",
        data: { username, session_duration: String(durationMinutes) },
    });
    return response;
};

// Enable/Disable MFA
export const setMFA = async (
    username: string,
    enable: boolean
): Promise<AdminResponse> => {
    const response = await fetcher("/admin/set-mfa", {
        method: "PUT",
        data: { username, enable },
    });
    return response;
};
